import React from "react";

const HowWeWork = () => {
  return <div>HowWeWork</div>;
};

export default HowWeWork;
